import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ETLReportingSetDropdownOptions,
    ETLReportingSetFunctionTypes,
    ETLReportingSetOperationTypes,
    ComplexNumericFunctionDropdownId
} from "../../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-function-operator-field",
    templateUrl: "./function-operator-field.component.html",
    styleUrls: ["./function-operator-field.component.scss"],
})
export class FunctionOperatorFieldComponent implements OnInit {
    @Output() addChilds = new EventEmitter();
    @Output() editInput = new EventEmitter();
    @Output() formChanged = new EventEmitter();

    public showSearch = false;
    public _numericData: any;
    public functionTypes: ETLReportingSetDropdownOptions[] = [];
    public operationTypes: ETLReportingSetDropdownOptions[] = [];
    public addFormulaPlaceholder = "";
    public functionPlaceholderText = "";

    showExpression = false;
    @Input() set numericData(data) {
        this._numericData = data;
        if (data.numericType === 'expression') {
            this.showHideExpression(true);
        }
        else {
            this.showHideExpression(false);
        }
    }
    get numericData() {
        return this._numericData;
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.initializeFunctionTypes();
        this.initializeOpertionType();
        if (!this.numericData.functionType) {
            this.numericData.functionType = this.functionTypes[0];
        }
    }

    constructor(private cvLocalizationService: CVLocalizationService) { }

    public initializeFunctionTypes() {
        this.functionTypes = [
            {
                id: ETLReportingSetFunctionTypes["No Function"],
                label: "No Function",
                orderId: ComplexNumericFunctionDropdownId.NoFunction
            },
            {
                id: ETLReportingSetFunctionTypes.Abs,
                label: "Abs",
                orderId: ComplexNumericFunctionDropdownId.Abs
            },
            {
                id: ETLReportingSetFunctionTypes.Cos,
                label: "Cos",
                orderId: ComplexNumericFunctionDropdownId.Cos
            },
            {
                id: ETLReportingSetFunctionTypes.Cosh,
                label: "Cosh",
                orderId: ComplexNumericFunctionDropdownId.Cosh
            },
            {
                id: ETLReportingSetFunctionTypes.Arccos,
                label: "Arccos",
                orderId: ComplexNumericFunctionDropdownId.Arccos
            },
            {
                id: ETLReportingSetFunctionTypes.Sin,
                label: "Sin",
                orderId: ComplexNumericFunctionDropdownId.Sin
            },
            {
                id: ETLReportingSetFunctionTypes.Sinh,
                label: "Sinh",
                orderId: ComplexNumericFunctionDropdownId.Sinh
            },
            {
                id: ETLReportingSetFunctionTypes.Arcsin,
                label: "Arcsin",
                orderId: ComplexNumericFunctionDropdownId.Arcsin
            },
            {
                id: ETLReportingSetFunctionTypes.Tan,
                label: "Tan",
                orderId: ComplexNumericFunctionDropdownId.Tan
            },
            {
                id: ETLReportingSetFunctionTypes.Tanh,
                label: "Tanh",
                orderId: ComplexNumericFunctionDropdownId.Tanh
            },
            {
                id: ETLReportingSetFunctionTypes.Arctan,
                label: "Arctan",
                orderId: ComplexNumericFunctionDropdownId.Arctan
            },
            {
                id: ETLReportingSetFunctionTypes.Sqrt,
                label: "Sqrt",
                orderId: ComplexNumericFunctionDropdownId.Sqrt
            },
            {
                id: ETLReportingSetFunctionTypes.Exp,
                label: "Exp",
                orderId: ComplexNumericFunctionDropdownId.Exp
            },
            {
                id: ETLReportingSetFunctionTypes.Log,
                label: "Log",
                orderId: ComplexNumericFunctionDropdownId.Log
            },
            {
                id: ETLReportingSetFunctionTypes.Round,
                label: "Round",
                orderId: ComplexNumericFunctionDropdownId.Round
            },
            {
                id: ETLReportingSetFunctionTypes.Truncate,
                label: "Truncate",
                orderId: ComplexNumericFunctionDropdownId.Truncate
            },
            {
                id: ETLReportingSetFunctionTypes.Floor,
                label: "Floor",
                orderId: ComplexNumericFunctionDropdownId.Floor
            },
            {
                id: ETLReportingSetFunctionTypes.Ceiling,
                label: "Ceiling",
                orderId: ComplexNumericFunctionDropdownId.Ceiling
            },
            {
                id: ETLReportingSetFunctionTypes.Sign,
                label: "Sign",
                orderId: ComplexNumericFunctionDropdownId.Sign
            },
        ];
    }
    public initializeOpertionType() {
        this.operationTypes = [
            {
                id: ETLReportingSetOperationTypes.Modulus,
                label: "Modulus",
            },
            {
                id: ETLReportingSetOperationTypes.Exponent,
                label: "Exponent",
            },
            {
                id: ETLReportingSetOperationTypes.Divide,
                label: "Divide",
            },
            {
                id: ETLReportingSetOperationTypes.Multiply,
                label: "Multiply",
            },
            {
                id: ETLReportingSetOperationTypes.Minus,
                label: "Minus",
            },
            {
                id: ETLReportingSetOperationTypes.Plus,
                label: "Plus",
            },
            {
                id: ETLReportingSetOperationTypes.Greater_Than,
                label: "Greater Than",
            },
            {
                id: ETLReportingSetOperationTypes.Less_Than,
                label: "Less Than",
            },
            {
                id: ETLReportingSetOperationTypes.Equal_To,
                label: "Equal To",
            },
        ];
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.addFormulaPlaceholder = this.getLocalizationString("Add_Formula", "Add Formula"); // to be given to cv team
            this.functionPlaceholderText = this.getLocalizationString("Select_Function", "Select Function"); // to be given to cv team
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
        return baseString;
    }

    addNewField() {
        this.addChilds.emit(true);
    }

    editInputClick(item) {
        this.editInput.emit(item);
    }

    showHideExpression(isShow) {
        this.showExpression = isShow;
    }

    formValueChanged() {
        this.formChanged.emit(this.numericData);
    }
}
